import styled from 'styled-components/native';

export const FlatList = styled.FlatList``;

export const InputContainer = styled.View`
  margin-top: 8px;
  margin-bottom: 32px;
  padding-horizontal: 16px;
`;

export const SectionContainer = styled.View`
  padding: 16px;
`;

export const Footer = styled.View`
  padding: 16px;
`;

export const Loading = styled.ActivityIndicator.attrs(({ theme }) => ({
  color: theme.color.base.c6,
}))`
  padding-bottom: 12px;
`;
